import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { changeMode } from 'redux/features/LoginSlice';
import {
  BlogArrowBack,
  BlogContainer,
  BlogHeaderStyle,
  ProfilePopoverContent,
} from './Blog.style';
import { CloseIcon, CustomPopover } from 'components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';
import { ReactComponent as DarkTheme } from 'assert/images/Common/darkTheme.svg';
import { ReactComponent as LightTheme } from 'assert/images/Common/lightTheme.svg';
import { ReactComponent as Translation } from 'assert/images/Common/translation.svg';
import { LanguageList } from 'assert/OptionList';
import clsx from 'clsx';

const BlogLayout = ({ children, hideBackArrow }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const windowLocation = window.location.pathname;
  const currentTheme = localStorage.getItem('mode');
  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const toggleTheme = () => {
    localStorage.setItem('mode', currentTheme === 'Dark' ? 'Light' : 'Dark');
    dispatch(changeMode(currentTheme === 'Dark' ? 'Light' : 'Dark'));
  };

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
    setOpenDropdown(false);
  };

  const renderLanguageList = () => {
    return (
      <ProfilePopoverContent>
        {LanguageList.map((lang) => {
          return (
            <div
              className={clsx(
                'language-item',
                language === lang.value && 'language-active-item'
              )}
              key={lang.value}
              onClick={() => handleLanguageChange(lang.value)}
            >
              {lang.label}
            </div>
          );
        })}
      </ProfilePopoverContent>
    );
  };

  return (
    <>
      <BlogHeaderStyle>
        <header className="header">
          <div className="header-brand" onClick={() => navigate('/signup')}>
            <WafyNetLogo />
            <h3 className="logo-title">WafyNet</h3>
          </div>
          <div className="option-header">
            <div onClick={toggleTheme}>
              {currentTheme === 'Dark' ? (
                <LightTheme className="icon-style" />
              ) : (
                <DarkTheme className="icon-style" />
              )}
            </div>
            <CustomPopover
              isOpen={openDropdown}
              handlePopoverClick={() => setOpenDropdown(true)}
              onClose={() => setOpenDropdown(false)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              action={<Translation className="icon-style" />}
              content={renderLanguageList()}
            />
          </div>
        </header>
      </BlogHeaderStyle>
      <BlogContainer>
        {windowLocation !== '/blog' && !hideBackArrow && (
          <BlogArrowBack className="post-back">
            <CloseIcon iconType={'back'} onClick={() => navigate(-1)} />
            <div>Back</div>
          </BlogArrowBack>
        )}
        <Outlet />
        {children}
      </BlogContainer>
    </>
  );
};
export default BlogLayout;
